window.location.pathname = '/products/muse-s-gen-2-subscription';